import { useTranslation } from 'react-i18next';

import { IntegrationType } from '@/shared/types/integration';
import { getChannelKey } from '@/util/channelName';

/** Marks where a replayed session moved to another channel, e.g. from WhatsApp to the web chat. */
export const ChannelDivider = ({ channel }: { channel: string }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2" role="separator">
      <div className="h-px flex-1 bg-border" />
      <span className="text-xs leading-4 font-medium text-muted-foreground">
        {t('try_it.channel_switched', { 0: t(getChannelKey(channel as IntegrationType)) })}
      </span>
      <div className="h-px flex-1 bg-border" />
    </div>
  );
};

type ChannelNode = { channel?: string; integration_id?: string | null };

/**
 * For each node, the channel it moved to when it is on another integration than the node before
 * it, else null. Two integrations of one channel count as a move. The first known one is where
 * the session started, so it gets no divider.
 */
export const channelSwitches = (nodes: ChannelNode[]): (string | null)[] => {
  let current: string | undefined;
  return nodes.map(({ channel, integration_id }) => {
    if (!channel) {
      return null;
    }
    const where = integration_id ?? channel;
    const switched = current !== undefined && where !== current;
    current = where;
    return switched ? channel : null;
  });
};
